import { FormPart } from '/react4xp/parts/form-part/form-part';

export default (props) => <FormPart {...props} />;
